import { z } from 'zod';

import { CompanyAchAccountId } from '../BrandedIds';
import { zodBrandedUuid } from '../utils';

export const CompanyAchAccount = z.object({
  id: zodBrandedUuid<CompanyAchAccountId>(),
  nickname: z.string(),
  lastFour: z.string(),
  bankName: z.string(),
  isActive: z.boolean(),
  createdAt: z.date(),
});
export type CompanyAchAccount = z.infer<typeof CompanyAchAccount>;
